<script lang="ts">
	import { wikiStyles } from '$lib/components/common/ui/wiki';
</script>

<article class="max-w-3xl mx-auto">
	<h1 class={wikiStyles.headerText}>Native Species</h1>

	<p class={wikiStyles.paragraphText}>
		Native species are plants, animals, and other organisms that have evolved in a particular region
		over thousands of years. They form the foundation of local ecosystems and play crucial roles in
		maintaining ecological balance.
	</p>

	<h2 class={wikiStyles.subheaderText}>Ecological Importance</h2>
	<ul class={wikiStyles.ulText}>
		<li>Support Local Food Webs</li>
		<li>Adapt to Local Climate Conditions</li>
		<li>Maintain Genetic Diversity</li>
		<li>Provide Essential Ecosystem Services</li>
		<li>Create Wildlife Habitat</li>
	</ul>

	<h2 class={wikiStyles.subheaderText}>Benefits in Local Projects</h2>
	<div class={wikiStyles.paragraphText}>
		<p class="mb-4">Native species offer numerous advantages:</p>
		<ul class={wikiStyles.ulText}>
			<li>Lower Maintenance Requirements</li>
			<li>Reduced Water Needs</li>
			<li>Diversity in People's Diets</li>
			<li>Natural Pest Resistance</li>
			<li>Support for Local Wildlife</li>
			<li>Cultural and Historical Connection</li>
		</ul>
	</div>

	<h2 class={wikiStyles.subheaderText}>Implementation Strategies</h2>
	<p class={wikiStyles.paragraphText}>
		Ways to incorporate native species in Local Bloom projects:
	</p>
	<ul class={wikiStyles.ulText}>
		<li>Native Plant Gardens</li>
		<li>Pollinator Corridors</li>
		<li>Rain Gardens</li>
		<li>Food Forests with Native Species</li>
		<li>Seed Saving and Exchange</li>
		<li>Educational Demonstrations</li>
	</ul>

	<h2 class={wikiStyles.subheaderText}>Related Articles</h2>
	<ul class="space-y-2 text-bloomBlueLightActive">
		<li><a href="/learn/wiki/ecosystem-restoration" class="underline">Ecosystem Restoration</a></li>
		<li><a href="/learn/wiki/food-forests" class="underline">Food Forests</a></li>
		<li><a href="/learn/wiki/bioregionalism" class="underline">Bioregionalism</a></li>
	</ul>
</article>
